import * as React from 'react';
import { connect } from 'react-redux';
import './PortablePossessions.css';
import { Card } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { showCallBackRequest } from '../../../actions/modalActions';

class RequestCallBack extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    getReplacmentValueStatus(replacementvalue) {
        let description = '';
        if (replacementvalue) {
            switch (replacementvalue) {
                case 'more': description = 'If the value of your item exceeds our limit, please call us on 0860 50 50 50 or tap on ‘Call me back’'
                    break;
                case 'less': description = 'If the value of your item is less than our minimum amount, please call us on 0860 50 50 50 or tap on ‘Call me back’';
                    break;
                default: description = '';
            }
        }
        return description;
    }

    handleCallMeBack() {
        this.props.dispatchShowCallMeBack()
    }

    componentWillMount() { }

    public render() {
        return (
            <>
                <Card className="content-box-padding-20px-with-box-shadow request-call-back-box">
                    <div className="row noma">
                        <div className="col-lg col-md col-12 nopa">
                            <p className="call-back-description">{this.getReplacmentValueStatus(this.props.sales.replacementCheckResult !== undefined ? this.props.sales.replacementCheckResult : null)}</p>
                        </div>
                        <div className="col-lg-1 nopa gutter"></div>
                        <div className="nopa ssp-replacement-value-callback-button-holder mobile-mt-20px">
                            <button className="btn btn-block btn-solid-red cursor-pointer" onClick={this.handleCallMeBack} id="CallMeBack">Call me back</button>
                        </div>
                    </div>
                </Card>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
        sales:state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowCallMeBack: () => dispatch(showCallBackRequest()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCallBack);